export default __webpack_public_path__ + "static/media/meditation.6c31a277.svg";